export enum KitAlertSeverity {
  CRITICAL = 'CRITICAL',
  WARNINGS = 'WARNINGS',
  PASSED = 'PASSED',
}

export enum AlertOverviewKey {
  FAILED = 'FAILED',
  PASSED = 'PASSED',
  IGNORED = 'IGNORED',
}

export enum KitAlertCardMode {
  DEFAULT = 'DEFAULT',
  IGNORED = 'IGNORED',
}
